import { axios } from '../index'

export default async function deleteManualGroupAutomation(groupId: string) {
  return await axios.delete(`/v1/groups/${groupId}`)
}
